import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import "./apply.css";
import UserHeader from '../userHome/userHeader/UserHeader';
import { useAppliedJobsMyQuery } from '../../slice/authApiSlice';
import { useNavigate } from 'react-router-dom';
import { generatePublicUrl } from '../../config/image';
import cImg2 from "../../assets/images/jobicon.png"; // ✅ fallback logo

function AppliedJobs() {
    const user = useSelector((state) => state.auth.userInfo);
    const token = useSelector((state) => state.auth.token);
    const navigate = useNavigate();
    const [jobs, setJobs] = useState([]);
    const { data: appliedJobs } = useAppliedJobsMyQuery();

    useEffect(() => {
        if (appliedJobs && Array.isArray(appliedJobs.jobs)) {
            setJobs(appliedJobs.jobs);
        }
    }, [appliedJobs]);

    const [currentPage, setCurrentPage] = useState(1);
    const jobsPerPage = 8;
    const indexOfLastJob = currentPage * jobsPerPage;
    const indexOfFirstJob = indexOfLastJob - jobsPerPage;
    const currentJobs = jobs.slice(indexOfFirstJob, indexOfLastJob);
    const totalPages = Math.ceil(jobs.length / jobsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const visitJobData = (data) => {
        navigate(`/job/${data.jobId}`, { state: { data } });
    }

    return (
        <div className='jobpage'>
            <div>
                <UserHeader />
                <h2 className='latest-header-job-design'>My applied jobs ({jobs?.length})</h2>
            </div>

            {jobs.length === 0 ? (
                <section className='job-outer1'>
                    <h2>Not yet applied to any jobs</h2>
                    <button>Apply now</button>
                </section>
            ) : (
                <>
                    <section className='job-outer'>
                        <div className='job-inner-page'>
                            {currentJobs?.map(jb => (
                                <div className='job-card' key={jb._id}>
                                    <div className='jd-outer'>
                                        <div className='job-img-det'>
                                            <img
                                                src={
                                                    jb?.company?.companyLogo
                                                        ? generatePublicUrl(jb.company.companyLogo)
                                                        : cImg2
                                                }
                                                alt="Company logo"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = cImg2;
                                                }}
                                            />
                                        </div>
                                        <div className='jd-outer-det-new'>
                                            <h2>{jb.title.length > 20 ? `${jb.title.slice(0, 20)}...` : jb.title}</h2>
                                            <p>{jb?.description.length > 52 ? `${jb?.description.slice(0, 52)}...` : jb?.description}</p>
                                            <div className='jdd-btn'>
                                                <button onClick={() => visitJobData(jb)}>See Details</button>
                                                <button>{jb?.status}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <div className="pagination">
                        {[...Array(totalPages).keys()].map(pageNumber => (
                            <button
                                key={pageNumber + 1}
                                onClick={() => paginate(pageNumber + 1)}
                                className={currentPage === pageNumber + 1 ? 'active' : ''}
                            >
                                {pageNumber + 1}
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}

export default AppliedJobs;
